import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import globalStyles from "../../global";

  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
const countries = [
  {
    name: "GHANA",
    x: "48%",
    y: "52%",
    info: {
      title: "GHANA",
      description: "UClean provides quality laundry services in Ghana, focusing on convenience and affordability for all.",
      locations: "40+",
      locationsLabel: "Facilities Across Ghana",
      cities: "10+",
      citiesLabel: "Cities Across Ghana",
      website: "#"
    }
  },
  {
    name: "UAE",
    x: "62%",
    y: "46%",
    info: {
      title: "UAE",
      description: "UClean serves the UAE with modern laundry facilities, emphasizing fast and hygienic service.",
      locations: "30+",
      locationsLabel: "Facilities Across UAE",
      cities: "7+",
      citiesLabel: "Cities Across UAE",
      website: "#"
    }
  },
  {
    name: "SOMALIA",
    x: "63%",
    y: "57%",
    info: {
      title: "SOMALIA",
      description: "UClean's presence in Somalia ensures access to reliable laundry solutions for families and professionals.",
      locations: "20+",
      locationsLabel: "Facilities Across Somalia",
      cities: "5+",
      citiesLabel: "Cities Across Somalia",
      website: "#"
    }
  },
  {
    name: "MAURITIUS",
    x: "67%",
    y: "72%",
    info: {
      title: "MAURITIUS",
      description: "In Mauritius, UClean is known for its eco-friendly laundry solutions and customer-focused service.",
      locations: "10+",
      locationsLabel: "Facilities Across Mauritius",
      cities: "2+",
      citiesLabel: "Cities Across Mauritius",
      website: "#"
    }
  },
  {
    name: "NEPAL",
    x: "74%",
    y: "42%",
    info: {
      title: "NEPAL",
      description: "UClean in Nepal brings affordable and efficient laundry solutions to urban and rural areas alike.",
      locations: "15+",
      locationsLabel: "Facilities Across Nepal",
      cities: "4+",
      citiesLabel: "Cities Across Nepal",
      website: "#"
    }
  },
  {
    name: "INDIA",
    x: "71%",
    y: "46%",
    info: {
      title: "INDIA",
      description: "UClean's Flagship Services In India Are Designed To Cater To Every Need, From Busy Professionals To Families. With Over 700+ Locations Across India, Our Promise Of Clean, Fast, And Affordable Laundry Is Delivered With Care.",
      locations: "700+",
      locationsLabel: "Facilities Across India",
      cities: "180+",
      citiesLabel: "Cities Across India",
      website: "https://www.uclean.in/"
    }
  },
  {
    name: "SRI LANKA",
    x: "74%",
    y: "55%",
    info: {
      title: "SRI LANKA",
      description: "UClean offers reliable laundry services in Sri Lanka, ensuring quality and customer satisfaction.",
      locations: "25+",
      locationsLabel: "Facilities Across Sri Lanka",
      cities: "8+",
      citiesLabel: "Cities Across Sri Lanka",
      website: "#"
    }
  }
];

// Pin SVG component using custom icon
const MapPin = ({ size = 32 }) => (
  <img 
    src={`${imageBaseUrl}icon_map.svg`}
    alt="Map Pin" 
    width={size} 
    height={size}
    style={{
      filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))"
    }}
  />
);

// Dialog/Tooltip component
function CountryDialog({ country, left, top, onClose, isMobile }) {
  if (!country) return null;
  
  const dialogStyle = isMobile ? {
    position: "fixed",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "calc(100vw - 40px)",
    maxWidth: "350px",
    background: globalStyles.colors.army_green,
    color: "#fff",
    borderRadius: "12px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
    zIndex: 1000,
    padding: "20px",
    fontSize: "14px",
    fontFamily: "system-ui, -apple-system, sans-serif",
    animation: "fadeInMobile 0.3s ease-out"
  } : {
    position: "absolute",
    left: `${left}px`,
    top: `${top}px`,
    minWidth: "280px",
    maxWidth: "320px",
    background: globalStyles.colors.army_green,
    color: "#fff",
    borderRadius: "12px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
    zIndex: 1000,
    padding: "40px 20px",
    fontSize: "14px",
    fontFamily: "system-ui, -apple-system, sans-serif",
    transform: "translateY(-10px)",
    animation: "fadeIn 0.2s ease-out"
  };
  
  return (
    <>
      {isMobile && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 999
          }}
          onClick={onClose}
        />
      )}
      <div style={dialogStyle}>
        <style>
          {`
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(-5px); }
              to { opacity: 1; transform: translateY(-10px); }
            }
            @keyframes fadeInMobile {
              from { opacity: 0; transform: translate(-50%, -50%) scale(0.9); }
              to { opacity: 1; transform: translate(-50%, -50%) scale(1); }
            }
          `}
        </style>
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            color: "#fff",
            position: "absolute",
            right: "12px",
            top: "8px",
            cursor: "pointer",
            fontSize: "20px",
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            opacity: 0.7,
            transition: "opacity 0.2s"
          }}
          onMouseEnter={(e) => e.target.style.opacity = "1"}
          onMouseLeave={(e) => e.target.style.opacity = "0.7"}
          aria-label="Close"
        >
          ×
        </button>
        <div style={{ 
          fontWeight: 700, 
          fontSize: "18px", 
          marginBottom: "10px",
          color: "white"
        }}>
          {country.info.title}
        </div>
        <div style={{ 
          lineHeight: 1.5, 
          marginBottom: "16px",
          fontSize: "13px"
        }}>
          {country.info.description}
        </div>
        <div style={{ 
          display: "flex", 
          gap: "16px", 
          marginBottom: "12px",
          flexWrap: "wrap"
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span style={{ 
              fontWeight: 700, 
              fontSize: "16px",
              color: "white"
            }}>
              {country.info.locations}
            </span>
            <span style={{ fontSize: "12px", opacity: 0.9 }}>
              {country.info.locationsLabel}
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span style={{ 
              fontWeight: 700, 
              fontSize: "16px",
              color: "white"
            }}>
              {country.info.cities}
            </span>
            <span style={{ fontSize: "12px", opacity: 0.9 }}>
              {country.info.citiesLabel}
            </span>
          </div>
        </div>
        {country.info.website !== "#" && (
          <a
            href="https://uclean.in/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              color: "white",
              textDecoration: "none",
              fontWeight: 600,
              fontSize: "13px",
              padding: "6px 12px",
              border: "1px solid #4fff79",
              borderRadius: "6px",
              transition: "all 0.2s",
              background: "transparent"
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "#4fff79";
              e.target.style.color = "#275839";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "transparent";
              e.target.style.color = "#4fff79";
            }}
          >
            Visit Website →
          </a>
        )}
      </div>
    </>
  );
}

export default function WorldMapWithCountryTooltip() {
  const [activeCountry, setActiveCountry] = useState(null);
  const [dialogPos, setDialogPos] = useState({ left: 0, top: 0 });
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handlePoint = (event, country) => {
    if (isMobile) {
      setActiveCountry(country);
      return;
    }
    
    const mapContainer = event.currentTarget.closest('[data-map-container]');
    const mapRect = mapContainer.getBoundingClientRect();
    const pinRect = event.currentTarget.getBoundingClientRect();
    
    let left = pinRect.left - mapRect.left + 20;
    let top = pinRect.top - mapRect.top - 20;
    
    // Adjust position to keep dialog within viewport
    const dialogWidth = 320;
    const viewportWidth = window.innerWidth;
    const rightEdge = mapRect.left + left + dialogWidth;
    
    if (rightEdge > viewportWidth - 20) {
      left = left - dialogWidth - 40;
    }
    
    if (top < 20) {
      top = pinRect.bottom - mapRect.top + 10;
    }
    
    setActiveCountry(country);
    setDialogPos({ left, top });
  };

  const handlePinClick = (event, country) => {
    event.preventDefault();
    event.stopPropagation();
    
    if (isMobile) {
      if (activeCountry?.name === country.name) {
        setActiveCountry(null);
      } else {
        setActiveCountry(country);
      }
    } else {
      handlePoint(event, country);
    }
  };

  const getPinSize = (countryName) => {
    if (isMobile) {
      return countryName === "INDIA" ? 20 : 16;
    }
    return countryName === "INDIA" ? 28 : 24;
  };


  return (
    <div style={{ 
      width: "100%", 
      background: "#ffffff",
      padding: isMobile ? "20px" : "40px 20px 60px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }}>
      {/* Title */}
      <div style={{
        textAlign: "center",
        marginBottom: isMobile ? "20px" : "40px",
        padding: isMobile ? "0 10px" : "0",
         
      }}>
      <Typography variant="h1_gothic" sx={{ fontSize: { xs: "24px", sm: "38px", md: "40px" } }}>
          COUNTRIES WHERE WE SERVE
        </Typography>
      </div>

      {/* Map Container */}
      <div
        data-map-container
        style={{
          position: "relative",
          width: "100%",
          maxWidth: "1200px",
          aspectRatio: isMobile ? "4/3" : "16/9",
          background: "white",
          borderRadius: isMobile ? "12px" : "16px",
          boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
          overflow: "hidden",
          minHeight: isMobile ? "300px" : "400px",
          margin: isMobile ? "0 10px" : "0"
        }}
      >
        {/* World Map Background */}
        <img 
          src="https://upload.wikimedia.org/wikipedia/commons/8/80/World_map_-_low_resolution.svg"
          alt="World Map"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: 0.15,
            filter: "grayscale(100%)",
            pointerEvents: "none"
          }}
        />

        {/* Country pins */}
        {countries.map((country) => (
          <div
            key={country.name}
            style={{
              position: "absolute",
              left: country.x,
              top: country.y,
              transform: "translate(-50%, -100%)",
              zIndex: 10,
              cursor: "pointer",
              transition: "transform 0.2s ease",
              touchAction: "manipulation"
            }}
            onClick={(e) => handlePinClick(e, country)}
            onMouseEnter={(e) => {
              if (!isMobile) {
                e.currentTarget.style.transform = "translate(-50%, -100%) scale(1.1)";
                handlePoint(e, country);
              }
            }}
            onMouseMove={(e) => !isMobile && handlePoint(e, country)}
            onMouseLeave={(e) => {
              if (!isMobile) {
                e.currentTarget.style.transform = "translate(-50%, -100%) scale(1)";
                setActiveCountry(null);
              }
            }}
            tabIndex={0}
            onFocus={(e) => !isMobile && handlePoint(e, country)}
            onBlur={() => !isMobile && setActiveCountry(null)}
            role="button"
            aria-label={`View information about ${country.name}`}
          >
            <MapPin size={getPinSize(country.name)} />
            <div
              style={{
                color: country.name === "INDIA" ? globalStyles.colors.army_green : "#333",
                fontWeight: country.name === "INDIA" ? 600 : 500,
                fontSize: isMobile ? "clamp(6px, 2vw, 12px)" : "clamp(12px, 1.5vw, 16px)",
                fontFamily: globalStyles.fonts.primaryGlobal,
                letterSpacing: "0.3px",
                whiteSpace: "nowrap",
                lineHeight: 1
              }}
            >
              {country.name}
            </div>
          </div>
        ))}

        {/* Country dialog */}
        {activeCountry && (
          <CountryDialog
            country={activeCountry}
            left={dialogPos.left}
            top={dialogPos.top}
            onClose={() => setActiveCountry(null)}
            isMobile={isMobile}
          />
        )}
      </div>
      
     
    </div>
  );
}